import { useCallback } from 'react'

import { showIncompleteElementList, showNotCompletedSections } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getProject } from 'services/Store/Project/selectors'
import { getEndCourseTrigger } from 'services/Store/Project/triggers'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const EndCourseButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  styles,
  block,
  mode,
  font,
  children,
}) => {
  const label = element?.value?.label
  const dispatch = useProjectDispatch()
  const trigger = useProjectContext(getEndCourseTrigger)
  const showIncompleteModal = useProjectContext(getProject)?.displayIncompleteModal

  const onClick = useCallback(() => {
    if (trigger.disabled && showIncompleteModal) {
      dispatch(showIncompleteElementList())
      dispatch(showNotCompletedSections())
    } else if (block) {
      dispatch(trigger.actionCreator())
    }
  }, [dispatch, block, trigger, showIncompleteModal])

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={!showIncompleteModal && trigger.disabled}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default EndCourseButtonElement
